<template>
  <div class="cards">
    <ClasseCard
      v-if="!readonly && isPorteurProjet"
      :projet-annuel="projetAnnuel"
      :can-delete="false"
      @add="added"
    />

    <div v-for="classe in localClasses.slice().reverse()" :key="classe.id">
      <ClasseCard
        :classe="classe"
        :projet-annuel="projetAnnuel"
        :can-delete="!readonly && isPorteurProjet"
        @delete="deleted"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { ClasseDTO, ProjetAnnuelDTO } from "@/model/bean/GeneratedDTOs"
import { defineComponent } from "vue"
import ClasseCard from "@/views/project/ClasseCard.vue"
import { TAG_TYPES_FOR_BOOKMARK_CARD } from "@/model/bean/EnumHelper"

export default defineComponent({
  name: "ProjetClasseView",
  components: {
    ClasseCard,
  },
  props: {
    projetAnnuel: {
      type: Object as () => ProjetAnnuelDTO,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isPorteurProjet: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["projet-annuel-updated", "dirtify-project", "trigger-validation"],
  data() {
    return {
      tagType: TAG_TYPES_FOR_BOOKMARK_CARD.CLASSES_ENGAGEES,
      iconNameInfo: "exclamation-circle",
      localClasses: [] as ClasseDTO[],
    }
  },
  watch: {
    projetAnnuel(): void {
      this.localClasses = [...this.projetAnnuel.classes]
    },
  },
  mounted() {
    this.localClasses = [...this.projetAnnuel.classes]
  },
  methods: {
    added(classe: ClasseDTO): void {
      // Ajouter à la liste locale
      this.localClasses.push(classe)

      const updatedProjetAnnuel = {
        ...this.projetAnnuel,
        classes: [...this.projetAnnuel.classes, classe],
      }
      this.$emit("projet-annuel-updated", updatedProjetAnnuel)
      this.$emit("dirtify-project")
      this.$emit("trigger-validation")
    },

    deleted(classe: ClasseDTO): void {
      // Supprimer de la liste locale
      this.localClasses = this.localClasses.filter(function (value) {
        return value !== classe
      })

      const updatedProjetAnnuel = {
        ...this.projetAnnuel,
        classes: this.projetAnnuel.classes.filter(function (value) {
          return value !== classe
        }),
      }
      this.$emit("projet-annuel-updated", updatedProjetAnnuel)
      this.$emit("dirtify-project")
      this.$emit("trigger-validation")
    },
  },
})
</script>

<style lang="scss">
.cards {
  display: flex;
  flex-wrap: wrap;
  height: auto;

  .BookmarkCard {
    height: auto;

    &.classes-engagees {
      .BookmarkCard-icon {
        width: 120px;
      }

      .BookmarkCard-tag {
        width: 120px;
        text-align: center;
        height: 50px;
        text-transform: none;
        font-size: 15px;
      }

      .BookmarkCard-content {
        padding: 10px;
      }
    }

    &.without-footer {
      .BookmarkCard-footer {
        display: none;
      }
    }
  }
}
</style>
